<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { useI18n } from 'vue-i18n';
import { CONTENT_TYPES, MESSAGE_VARIANTS } from '../constants.js';
import { useMessageContext } from '../provider.js';
import { useInbox } from 'dashboard/composables/useInbox';

const { content, contentAttributes, contentType, variant } =
  useMessageContext();
const { t } = useI18n();
const { isAWebWidgetInbox } = useInbox();

const darkSurfaceVariants = [
  MESSAGE_VARIANTS.AGENT,
  MESSAGE_VARIANTS.BOT,
  MESSAGE_VARIANTS.TEMPLATE,
];

const isDarkSurfaceVariant = computed(() =>
  darkSurfaceVariants.includes(variant.value)
);

const responseLabelTextClass = computed(() => {
  return isDarkSurfaceVariant.value ? 'text-white/70' : 'text-n-slate-11';
});

const responseBodyTextClass = computed(() => {
  return isDarkSurfaceVariant.value ? 'text-white' : 'text-n-slate-12';
});

const formValues = computed(() => {
  if (contentType.value === CONTENT_TYPES.FORM) {
    const { items, submittedValues = [] } = contentAttributes.value;

    if (submittedValues.length) {
      return submittedValues.map(submittedValue => {
        const item = items.find(
          formItem => formItem.name === submittedValue.name
        );
        return {
          title: submittedValue.value,
          value: submittedValue.value,
          label: item?.label,
        };
      });
    }

    return [];
  }

  if (contentType.value === CONTENT_TYPES.INPUT_SELECT) {
    const [item] = contentAttributes.value?.submittedValues ?? [];
    if (!item) return [];

    return [
      {
        title: item.title,
        value: item.value,
        label: '',
      },
    ];
  }

  return [];
});
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="csat">
    <span
      v-dompurify-html="content"
      :title="content"
      :class="responseBodyTextClass"
    />
    <dl v-if="formValues.length" class="mt-4">
      <template v-for="item in formValues" :key="item.title">
        <dt class="italic mt-2" :class="responseLabelTextClass">
          {{ item.label || t('CONVERSATION.RESPONSE') }}
        </dt>
        <dd :class="responseBodyTextClass">{{ item.title }}</dd>
      </template>
    </dl>
    <div
      v-else-if="isAWebWidgetInbox"
      class="my-2 font-medium"
      :class="responseBodyTextClass"
    >
      {{ t('CONVERSATION.NO_RESPONSE') }}
    </div>
  </BaseBubble>
</template>
